module.exports = __webpack_public_path__ + "media/images/lp/bg_feature3-d5d9a08a9053420f0d80d9415dbda31e.png";